import { BankType, OutDebt } from '../generated/graphql';

const betaBankPaymentLinks: { [key in BankType]?: string } = {
  [BankType.BancoDavivienda]: 'Dav',
  [BankType.Bbva]: 'Bbva',
};

export const getBetaPaymentLink = (outDebt: OutDebt, gT: any) => {
  const bankSuffix = betaBankPaymentLinks[outDebt.bank] || '';
  return gT(`paymentLink${bankSuffix}`);
};
